import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  canUseCallTracking,
  canUseVoip,
  fetchOrganizationFeatures,
} from 'resources/Organization/Features/FeaturesData';

import { forceFetchData } from 'components/Common/Data/DataFetcherSuperUtils';
import { useDataFetcherV2 } from 'components/Common/Data/useDataFetcher';

import { fetchMissedCallCount, getUnacknowledgedMissedCallCount } from '../Resources/CallLogs/Data';

export const useMissedCallCount = () => {
  const dispatch = useDispatch();
  const [featuresFetched] = useDataFetcherV2(fetchOrganizationFeatures);
  const hasVoipFeature = useSelector(canUseVoip);
  const hasCallTrackingFeature = useSelector(canUseCallTracking);
  const [doneFetching, setDoneFetching] = useState(false);

  const hasVoiceFeature = hasVoipFeature || hasCallTrackingFeature;

  useEffect(() => {
    const getMissedCallCount = async () => {
      if (featuresFetched && hasVoiceFeature) {
        setDoneFetching(false);
        try {
          await dispatch(forceFetchData(fetchMissedCallCount, []));
        } finally {
          setDoneFetching(true);
        }
      }
    };
    getMissedCallCount();
  }, [dispatch, hasVoiceFeature, featuresFetched]);

  return [doneFetching || (featuresFetched && !hasVoiceFeature), useSelector(getUnacknowledgedMissedCallCount)];
};
